import React from 'react';

const IconQuiz = () => {
  return (
    <svg
      strokeMiterlimit="10"
      version="1.1"
      viewBox="0 0 599.99998 599.99999"
      fit-margin-top="0"
      fit-margin-left="0"
      fit-margin-right="0"
      fit-margin-bottom="0"
    >
      <g id="g37321" className="sm-home__quiz-icon">
        <path id="rect1148" className="sm-home__quiz-icon-styling" d="M 0.5,0.5 H 46.900002 V 55.833332 H 0.5 Z" />
        <path
          d="m 21.375,15.908333 c 5.708333,0 11.416667,0 17.125,0"
          id="path2075"
          className="sm-home__quiz-icon-styling"
        />
        <path
          d="m 21.375,21.283333 c 5.708333,0 11.416667,0 17.125,0"
          id="path2075-2"
          className="sm-home__quiz-icon-styling"
        />
        <path
          d="m 21.375,35.220833 c 5.708333,0 11.416667,0 17.125,0"
          id="path2075-4"
          className="sm-home__quiz-icon-styling"
        />
        <path
          d="m 21.375,40.595833 c 5.708333,0 11.416667,0 17.125,0"
          id="path2075-2-7"
          className="sm-home__quiz-icon-styling"
        />
        <g aria-label="Q" id="text7038">
          <path
            d="m 17.421,22.670333 -1.128,-0.924 c 0.828,-0.912 1.236,-2.028 1.236,-3.42 0,-2.724 -1.704,-4.56 -4.224,-4.56 -2.532,0 -4.224,1.836 -4.224,4.584 0,2.736 1.692,4.584 4.224,4.584 0.876,0 1.584,-0.192 2.292,-0.612 l 1.26,1.044 z m -3.024,-2.472 -0.552,0.672 0.888,0.744 c -0.516,0.252 -0.912,0.336 -1.44,0.336 -1.86,0 -3.096,-1.44 -3.096,-3.6 0,-2.16 1.236,-3.6 3.108,-3.6 1.86,0 3.108,1.44 3.108,3.588 0,1.14 -0.3,2.004 -0.948,2.736 z"
            id="path18"
            className="sm-home__quiz-icon-text-styling"
          />
        </g>
        <g aria-label="A" id="text7038-2">
          <path
            d="m 15.023938,39.670958 0.9,2.628 h 1.247999 l -3.072,-8.748 h -1.439999 l -3.1200005,8.748 h 1.1879995 l 0.924,-2.628 z m -0.312,-0.936 h -2.784 l 1.44,-3.984 z"
            id="path21"
            className="sm-home__quiz-icon-text-styling"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconQuiz;
